import { deterministicHash } from '../contract/stable.js';
import { validateTransition } from '../contract/transition-log.js';

export const AUDIT_KEYS = Object.freeze(['decision','demo_id','evidence','fixture_hash','fixture_path','mode','normative_ids','pass','rationale','timestamp_utc']);

export function buildAuditEntry(scenario, state) {
  const decision = state.decisions.at(-1)?.decision || 'DENY';
  const request = state.requests.at(-1);
  const p = request?.predicateResults || {};
  const transitionIndex = state.transitionRecords.length - 1;
  const expectedPreviousHash = transitionIndex <= 0 ? 'GENESIS' : state.transitionRecords[transitionIndex - 1].recordHash;
  const transitionValid = transitionIndex >= 0 ? validateTransition(state.transitionRecords[transitionIndex], { expectedPreviousHash }) : false;
  const expectedCanonical = scenario.expectedFinalState === 'CANONICAL';
  const actualCanonical = state.canonicalRecords.length > 0;
  return {
    decision,
    demo_id: 'experience-entry-gate',
    evidence: [
      'commit_class_before=ASSOCIATIVE',
      `promotion_explicit=${Boolean(request)}`,
      `independent_dimension_count=${p.independentDimensionCount ?? 0}`,
      `required_dimension_count=${p.requiredDimensionCount ?? 2}`,
      `provenance_complete=${p.provenanceComplete ?? false}`,
      `regime_status=${request?.regimeSnapshot?.status || state.regime.status}`,
      `transition_record_valid=${transitionValid}`,
      `commit_class_after=${actualCanonical ? 'CANONICAL' : 'ASSOCIATIVE'}`
    ],
    fixture_hash: deterministicHash(scenario.fixtureContent),
    fixture_path: scenario.fixturePath,
    mode: scenario.mode,
    normative_ids: scenario.normativeIds,
    pass: expectedCanonical === actualCanonical && decision === scenario.expectedDecision,
    rationale: actualCanonical
      ? 'Canonical promotion completed only after predicates, authorization, and transition-record checks passed.'
      : decision === 'QUARANTINE' ? 'The request and evidence packet were quarantined; the trace remained associative.'
        : 'The experience remained associative because canonical-entry requirements were not satisfied.',
    timestamp_utc: '2026-01-15T14:00:00.000Z'
  };
}

export function buildDetailedTrace(scenario, state) {
  return {
    demoId: 'experience-entry-gate', scenario: { scenarioId: scenario.scenarioId, fixtureId: scenario.fixtureId, seed: scenario.seed, configuration: scenario.configuration },
    events: state.events, traces: state.traces, promotionRequests: state.requests, governanceDecisions: state.decisions,
    transitionRecords: state.transitionRecords, canonicalRecords: state.canonicalRecords, quarantineRecords: state.quarantineRecords,
    rendererTransitionSequence: state.rendererTransitions, timeline: state.timeline
  };
}

export const toAuditJsonl = (entry) => `${JSON.stringify(entry)}\n`;
export const toTraceJson = (trace) => `${JSON.stringify(trace, null, 2)}\n`;
export function isParseableEvidenceToken(token) { return /^[a-z][a-z0-9_]*=(?:[^\s]+|"[^"]*")$/.test(token); }
